import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { useRouterExt } from "../../hooks/useRouterExt";
import { routes } from "src/shared/routes";
import { TmAccountDetails } from "../TmAccountDetails";
import { Box } from "@mui/material";
import { useGroupInviteFlow } from "src/components/feature/groupInviteFlow/useGroupInviteFlow";
import React from "react";

export const useRemoveGroupMemberConfirmModal = createState({
  isOpen: false,
  onConfirm: async () => {},
});

export function RemoveGroupMemberConfirmModal() {
  const modalState = useRemoveGroupMemberConfirmModal();
  const [isConfirming, setIsConfirming] = React.useState(false);

  const onClose = () => {
    modalState.reset();
  };

  return (
    <DynamicModal
      isOpen={modalState.isOpen}
      title="Remove Group Member"
      description={
        <Box py={1}>
          Are you sure want to remove this member from the group?
        </Box>
      }
      onClose={onClose}
      slot={{
        primaryButton: {
          label: "Confirm",
          isLoading: isConfirming,
          isDisabled: isConfirming,
          onClick: async () => {
            setIsConfirming(true);
            await modalState.onConfirm();
            setIsConfirming(false);
            onClose();
          },
        },
        secondaryButton: {
          label: "Cancel",
          onClick: () => onClose(),
        },
      }}
    />
  );
}
